import { baseApi, BASE_API_URL } from "./baseApi";

export const cartApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    postSaveCurrentSMCart: builder.mutation({
      query: ({ user_identifier, distributor }) => ({
        baseUrl: BASE_API_URL,
        url: `/cart/save-cart`,
        method: "POST",
        body: JSON.stringify({
          distributor: distributor,
        }),
        headers: {
          "User-Identifier": user_identifier,
        },
      }),
    }),
  }),
});

export const { usePostSaveCurrentSMCartMutation } = cartApi;
